import { BaseService } from '../../infra/base.service'
import type { Service } from './service'
import type { ServicesRepository } from './services.repository'

export class ServicesService extends BaseService<Service> {
    constructor(private rep: ServicesRepository) {
        super(rep)
    }

    async getServiceNames(params, useCacheIfNewerThanThisInSeconds: number = 0) {
        return await this.rep.getServiceNames(params, useCacheIfNewerThanThisInSeconds)
    }

    async recalculate(serviceId: string) {
        return await this.rep.recalculate(serviceId)
    }
}
